import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d8929c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4d8929c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8929c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedMapAutoComplete: require('/app/components/ui/shared/map/AutoComplete.vue').default,UiSharedMapGoogle: require('/app/components/ui/shared/map/Google.vue').default,UiSharedPaginations: require('/app/components/ui/shared/Paginations.vue').default})
